import React, { useEffect, useState, useRef, useCallback } from "react";
import { ApiService } from "../ApiService";
import { ModalForAll } from "../global/ModalForAll";
import CallApi from "../../data/CallApi";
import { debounce } from "lodash";
import { Preloader } from "../Preloader";

export const ModalSearchClienteVC = ({ isOpen, onClose, onUserSelect, selectedSucursal }) => {
	const [searchResults, setSearchResults] = useState([]);
	const [highlightedIndex, setHighlightedIndex] = useState(-1);
	const focusSearch = useRef(null);
	const [stateLoader, setStateLoader] = useState(false);

	const debouncedSearch = useCallback(
		debounce(async (item) => {
			const textSearch = String(item.target.value).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

			if (textSearch.length >= 2) {
				setStateLoader(true)
				const fetch_request = await CallApi({
					url: `api/company/client/search?find_string=${textSearch}&key_branch=${selectedSucursal}`
				});
				const list_search = fetch_request || [];
				setSearchResults(list_search);
				setStateLoader(false)
			} else {
				setSearchResults([]);
			}
		}, 1000),
		[]
	);

	const handleResultClick = (client) => {
		onUserSelect(client);
		setSearchResults([]);
		onClose(false);
	};

	useEffect(() => {
		if (isOpen) focusSearch.current.focus();
	}, [isOpen])

	if (!isOpen) return null;

	return (
		<ModalForAll stateModal={isOpen} setStateModal={onClose} className="modal-content-search">
			<h3 style={{ fontSize: "22px", marginBottom: "10px" }}>Buscar Cliente</h3>

			<div className="search-container">
				<input
					id="search_client"
					type="text"
					className="search-input"
					placeholder="Buscar por nombre o teléfono..."
					ref={focusSearch}
					onChange={debouncedSearch}
					readOnly={stateLoader}
				// onKeyDown={handleKeyDown}
				/>
				<ul>
					{
						stateLoader ? <Preloader /> : (
							searchResults.length > 0 ? searchResults?.map((client, index) => (
								<li
									key={client.fullName}
									className={`search-result-item-user`}
									onClick={() => handleResultClick(client)}>
									{`${client.fullName} - ${client.phone}`}
								</li>
							)) : (
								<li style={{ textAlign: 'center' }}>Sin resultados...</li>
							)
						)
					}
				</ul>
			</div>
		</ModalForAll>
	);
};
